import React from 'react';

import SaveAltIcon from '@material-ui/icons/SaveAlt';

export default function DownloadButton(props)
{
  return {
    color : "inherit",
    label : "ダウンロード",
    "aria-label" : "PDFファイルをダウンロード",
    icon : <SaveAltIcon />,
    ...props
  }
}